// src/components/AdminRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, userInfo } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Check if user is admin
  // Note: userInfo might be null if the fetch failed, even if user is logged in.
  // In that case, we probably shouldn't allow access to admin pages.
  if (!userInfo || !userInfo.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
